module.exports = __webpack_public_path__ + "static/media/SIDHANTH-NAIDU.e80e27be.png";